import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
	providedIn: 'root'
})
export class AuthCoreService {

	constructor(public jwtHelper: JwtHelperService) {
	}

	determinerLangueDepuisToken(): string {
		const token = this.decoderToken();
		if (token != null && token?.langue) {
			return token.langue;
		}
		else {
			return 'fr';
		}
	}

	isAuthenticated(): boolean {
		const token = localStorage.getItem('access_token');
		if (token != null) {
			return !this.jwtHelper.isTokenExpired(token);
		}
		return false;
	}

	/**
	 * Récupère le login de l'utilisateur connecté.
	 *
	 * @return Le login de l'utilisateur connecté.
	 */
	loginUtilisateurConnecte(): string {
		const token = this.decoderToken();
		return token?.sub;
	}

	/**
	 * Détermine si l'utilisateur connecté est admin
	 */
	isAdminConnecte(): boolean {
		const token = this.decoderToken();
		return token != null && token?.droits && token?.droits.indexOf('ADMINISTRATION') >= 0;
	}

	droitsUtilisateurConnecte(): string[] {
		const token = this.decoderToken();
		return token != null && token?.droits;
	}

	decoderToken(): any {
		if (this.isAuthenticated()) {
			return this.jwtHelper.decodeToken(this.getToken());
		}
		return null;
	}

	saveToken(headers) {
		const token = headers.get('authorization');
		if (token != null) {
			localStorage.setItem('access_token', token);
		}
	}

	/**
	 * Sauvegarde le token d'authentification de Nuxeo.
	 *
	 * @param nuxeoToken Le token d'authentification de Nuxeo.
	 */
	saveTokenGed(nuxeoToken) {
		if (nuxeoToken != null) {
			localStorage.setItem('nuxeo_token', nuxeoToken);
		}
	}

	getToken(): string {
		const token = localStorage.getItem('access_token');
		return token ? token : '';
	}

	/**
	 * Permet de récupérer le token d'authentification de Nuxeo.
	 */
	getTokenGed(): string {
		const token = localStorage.getItem('nuxeo_token');
		return token ? token : '';
	}
}
